import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=5095eef4&scoped=true"
import script from "./PaymentMethod.vue?vue&type=script&lang=js"
export * from "./PaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=5095eef4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5095eef4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5095eef4')) {
      api.createRecord('5095eef4', component.options)
    } else {
      api.reload('5095eef4', component.options)
    }
    module.hot.accept("./PaymentMethod.vue?vue&type=template&id=5095eef4&scoped=true", function () {
      api.rerender('5095eef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/PaymentMethod.vue"
export default component.exports